module.exports = __webpack_public_path__ + "static/media/q1.97ce2a22.svg";